import { Instance, applySnapshot, getSnapshot, types } from 'mobx-state-tree'
import { RootStore } from '../store'

export enum filterTypes {
  applicationStatus = 'applicationStatus',
  level = 'level',
  status = 'status',
  auditType = 'auditType',
}
let initialState = {}

export const Filters = types
  .model('Filters', {
    applicationStatus: types.array(types.optional(types.string, 'Pending For Approval')),
    isFiltersApplied: types.optional(types.boolean, false),
    allFieldsSelected: types.optional(types.boolean, false),
    levelSelected: types.optional(types.string, 'ALL'),
    allLevelsSelected: types.optional(types.boolean, false),
    statusSelected: types.optional(types.string, 'ALL'),
    allStatusSelected: types.optional(types.boolean, false),
    auditType: types.array(types.optional(types.string, 'ALL')),
    allAuditTypesSelected: types.optional(types.boolean, false),
  })
  .actions((self) => ({
    saveState(): void {
      initialState = getSnapshot(self)
    },
    resetState(): void {
      try {
        applySnapshot(self, initialState)
      } catch (e) {
        RootStore.message.handleError(e)
      }
    },
    updateFilters(mode: filterTypes, value: string): void {
      if (mode === 'applicationStatus') {
        if (value === 'ALL') {
          if (!self.applicationStatus?.includes(value)) {
            self.applicationStatus = JSON.parse(
              JSON.stringify(['ALL', 'Completed', 'Approved', 'Rejected', 'Pending For Approval', 'Error']),
            )
            self.allFieldsSelected = value === 'ALL'
          }
          return
        }
        if (!self.applicationStatus?.includes(value)) {
          if (self.applicationStatus?.includes('ALL')) {
            self.applicationStatus.remove('ALL')
          }
          self.applicationStatus = JSON.parse(JSON.stringify([...self.applicationStatus, value]))
          if (
            self.applicationStatus.length === 4 &&
            self.applicationStatus?.includes('Completed') &&
            self.applicationStatus?.includes('Rejected') &&
            self.applicationStatus?.includes('Error') &&
            self.applicationStatus?.includes('Pending For Approval')
          ) {
            self.allFieldsSelected = true
            self.applicationStatus = JSON.parse(JSON.stringify([...self.applicationStatus, 'ALL']))
          }
        } else {
          if (self.applicationStatus?.includes('ALL')) {
            self.applicationStatus.remove('ALL')
          }
          self.applicationStatus.remove(value)
        }
      }
      if (mode === 'level') {
        self.levelSelected = value
        self.allLevelsSelected = value === 'ALL'
      }
      if (mode === 'status') {
        self.statusSelected = value
        self.allStatusSelected = value === 'ALL'
      }
      if (mode === 'auditType') {
        if (value === 'ALL') {
          if (!self.auditType?.includes(value)) {
            self.auditType = JSON.parse(JSON.stringify(['ALL', 'DIRECTOR', 'AUTHORISED_SIGNATORY', 'CIN', 'UBO']))
            self.allAuditTypesSelected = value === 'ALL'
          } else {
            self.auditType = JSON.parse(JSON.stringify([]))
            self.allAuditTypesSelected = false
          }
          return
        }
        if (!self.auditType?.includes(value)) {
          if (self.auditType?.includes('ALL')) {
            self.auditType.remove('ALL')
          }
          self.auditType = JSON.parse(JSON.stringify([...self.auditType, value]))
          if (
            self.auditType.length === 4 &&
            self.auditType?.includes('DIRECTOR') &&
            self.auditType?.includes('AUTHORISED_SIGNATORY') &&
            self.auditType?.includes('CIN') &&
            self.auditType?.includes('UBO')
          ) {
            self.allAuditTypesSelected = true
            self.auditType = JSON.parse(JSON.stringify([...self.auditType, 'ALL']))
          }
        } else {
          if (self.auditType?.includes('ALL')) {
            self.auditType.remove('ALL')
          }
          self.auditType.remove(value)
        }
      }
    },
    updateAllFieldsSelected(mode: filterTypes, value: boolean) {
      const own = self
      if (mode === 'applicationStatus') {
        own.allFieldsSelected = value
      }
      if (mode === 'level') {
        self.allLevelsSelected = true
      }
      if (mode === 'status') {
        self.allStatusSelected = true
      }
      if (mode === 'auditType') {
        self.allAuditTypesSelected = true
      }
    },
    restoreFiltersToDefaults() {
      self.applicationStatus = JSON.parse(
        JSON.stringify(['ALL', 'Completed', 'Approved', 'Rejected', 'Pending For Approval', 'Error']),
      )
      self.auditType = JSON.parse(JSON.stringify(['ALL', 'DIRECTOR', 'AUTHORISED_SIGNATORY', 'CIN', 'UBO']))
    },
  }))
  .views((self) => ({
    get getFilterData(): any {
      const data = {
        applicationStatus: self.applicationStatus,
        isFiltersApplied: self.isFiltersApplied,
        allFieldsSelected: self.allFieldsSelected,
        levelSelected: self.levelSelected,
        allLevelsSelected: self.allLevelsSelected,
        statusSelected: self.statusSelected,
        allStatusSelected: self.allStatusSelected,
        auditType: self.auditType,
      }
      return data
    },
    checkSelected(mode: filterTypes, value: string): any {
      if (self?.[mode]?.includes(value)) {
        return true
      }
      return false
    },
  }))

export const defaultSelectedFilters = Filters.create({
  isFiltersApplied: false,
  applicationStatus: ['Pending For Approval'],
  allFieldsSelected: false,
  auditType: ['ALL', 'DIRECTOR', 'AUTHORISED_SIGNATORY', 'CIN', 'UBO'],
})
export type FilterType = Instance<typeof Filters>
